import React from "react";
import { FiAward, FiUsers, FiTarget } from "react-icons/fi";
import "../../styles/challenges.css";

export default function DoctoralCompetition() {
  return (
    <div className="challenges-container">
      <section className="challenge-hero">
        <div className="challenge-hero-content">
          <h1>Doctoral Competition</h1>
          <p className="challenge-subtitle">Excellence in Research</p>
        </div>
      </section>

      <section className="challenge-content">
        <div className="content-wrapper">
          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>About the Competition</h3>
            </div>
            <p>
              The Doctoral Competition is designed to recognize and celebrate the outstanding research 
              conducted by doctoral candidates. This prestigious event provides an opportunity for emerging 
              researchers to showcase their work to a panel of distinguished experts and the academic community.
            </p>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Key Features</h3>
            </div>
            <div className="features-grid">
              <div className="feature-card">
                <FiTarget className="feature-icon" />
                <h3>Research Excellence</h3>
                <p>Showcase cutting-edge doctoral research</p>
              </div>
              <div className="feature-card">
                <FiUsers className="feature-icon" />
                <h3>Networking</h3>
                <p>Connect with accomplished researchers</p>
              </div>
              <div className="feature-card">
                <FiAward className="feature-icon" />
                <h3>Recognition</h3>
                <p>Win prestigious awards and certificates</p>
              </div>
            </div>
          </div>

          <div className="challenge-section">
            <div className="section-header-v2">
              <span className="accent-line"></span>
              <h3>Eligibility</h3>
            </div>
            <ul className="eligibility-list">
              <li>Currently enrolled as a doctoral candidate</li>
              <li>Original research conducted within the past 2 years</li>
              <li>Research not previously published in major venues</li>
              <li>Willingness to present findings at the competition</li>
            </ul>
          </div>

          <div className="challenge-section cta-section">
            <button className="cta-button">Submit Your Research</button>
          </div>
        </div>
      </section>
    </div>
  );
}
